import type { ScalarFieldValueType, TableScalarValue } from '../model';

export interface DataExportField {
  /** Canonical/effective property key used to read the snapshot. */
  readonly sourceField: string;
  /** Human-readable, unique field name written to the portable file. */
  readonly outputField: string;
  readonly type: ScalarFieldValueType;
  readonly origin: 'joined' | 'native';
}

export interface TabularDataExport {
  readonly fields: readonly DataExportField[];
  readonly rows: readonly (readonly TableScalarValue[])[];
}

export type VectorExportScope = 'all' | 'selected';
export type VectorExportFormat = 'csv' | 'geojson';

export class DataExportError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DataExportError';
  }
}
